import { SVGProps } from "react";

const PhoneIcon = ({ fill, ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.1662 9.98981L10.3441 8.71677C10.1058 8.5506 9.8273 8.46298 9.5385 8.46298C9.07927 8.46298 8.6482 8.6882 8.38562 9.06503L7.96265 9.6712C7.25376 9.19577 6.46274 8.53192 5.70867 7.77798C4.95473 7.02405 4.29102 6.23303 3.81572 5.52414L4.42162 5.10117C4.73047 4.88611 4.93674 4.56393 5.00224 4.19424C5.06761 3.82483 4.98522 3.45157 4.76988 3.14258L3.49712 1.3205C3.23097 0.939819 2.80155 0.712402 2.34822 0.712402C2.19112 0.712402 2.03703 0.740143 1.89037 0.79425C1.72379 0.855774 1.5686 0.931305 1.41644 1.02689L1.16486 1.20404C1.10196 1.25293 1.04346 1.30649 0.987428 1.36252C0.680498 1.66931 0.462694 2.05768 0.339784 2.51691C-0.184676 4.48291 1.11459 7.45581 3.57279 9.914C5.63712 11.9783 8.11714 13.2607 10.0448 13.261C10.375 13.261 10.6863 13.2225 10.97 13.1467C11.4292 13.024 11.8176 12.8062 12.1247 12.4991C12.1804 12.4433 12.2337 12.3848 12.2908 12.3109L12.4681 12.058C12.5548 11.9196 12.6302 11.7644 12.6925 11.5966C12.9069 11.017 12.6905 10.3562 12.1662 9.98981Z"
        fill={fill ?? "#1F1F1F"}
      />
    </svg>
  );
};

export default PhoneIcon;
